<template>
  <div class="row">
    <div class="col-md-12">
      <!-- <div class="pull-left">
        <router-link to="/categories" class="btn btn-orange"><i class="ti-arrow-left"></i> {{$t('general.back')}}</router-link>
      </div> -->
      <p  class="clearfix"></p>
      <category-form :route="route" @on-submit="onCategorySubmit"></category-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import CategoryForm from './CategoryForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      CategoryForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        categoryModel: {},
        category: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onCategorySubmit (model, isValid) {
        this.categoryModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Categories/CategoryAdd.vue